export default {
  MERCH_CARD: {
    purchaseMotions: {
      'marketing-hub-starter': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'operations-hub-professional': [{
        key: 'trial'
      }, {
        key: 'buyTouchless'
      }],
      'cms-hub-professional-onboarding': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'tech-service-dedicated-ip-for-email': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'web-hosting-custom-ssl-pack': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'service-hub-starter': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'technical-consulting-ongoing': [{
        key: 'talkToSales'
      }],
      'sales-hub-starter': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'service-hub-enterprise': [{
        key: 'talkToSales'
      }],
      'cms-hub-enterprise': [{
        key: 'talkToSales'
      }, {
        key: 'trial'
      }],
      'strategic-consulting-ongoing': [{
        key: 'talkToSales'
      }],
      'service-hub-enterprise-onboarding': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'sales-hub-enterprise': [{
        key: 'talkToSales'
      }],
      'service-hub-starter-onboarding': [{
        key: 'talkToSales'
      }],
      'training-agency-marketing-hub-fundamentals': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'domains-limit-increase': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'marketing-hub-professional': [{
        key: 'talkToSales'
      }],
      'premium-consulting': [{
        key: 'talkToSales'
      }],
      'api-limit-increase': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'transactional-email': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'marketing-hub-starter-onboarding': [{
        key: 'talkToSales'
      }],
      'sales-hub-enterprise-onboarding': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'operations-hub-enterprise': [{
        key: 'trial'
      }, {
        key: 'talkToSales'
      }],
      'cms-hub-professional': [{
        key: 'talkToSales'
      }, {
        key: 'trial'
      }],
      'ads-limit-increase': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'brazil-onboarding': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'marketing-hub-enterprise': [{
        key: 'talkToSales'
      }],
      'cms-hub-enterprise-onboarding': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'sales-hub-professional': [{
        key: 'talkToSales'
      }],
      'marketing-hub-professional-onboarding': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'strategic-consulting-monthly': [{
        key: 'talkToSales'
      }],
      'operations-hub-starter': [{
        key: 'buyTouchless'
      }],
      'sales-hub-professional-onboarding': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'service-hub-professional': [{
        key: 'talkToSales'
      }],
      'sales-hub-starter-onboarding': [{
        key: 'talkToSales'
      }],
      'cms-hub-starter': [{
        key: 'buyTouchless'
      }],
      'service-hub-professional-onboarding': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'brand-domain': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'hubspot-for-startups-setup': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'reporting-limit-increase': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'transcription-limit-increase': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }]
    }
  },
  CALCULATOR: {
    purchaseMotions: {
      'marketing-hub-starter': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'operations-hub-professional': [{
        key: 'buyTouchless'
      }],
      'tech-service-dedicated-ip-for-email': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'cms-hub-professional-onboarding': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'service-hub-starter': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'web-hosting-custom-ssl-pack': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'phone-limit-increase': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'technical-consulting-ongoing': [{
        key: 'talkToSales'
      }],
      'sales-hub-starter': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'service-hub-enterprise': [{
        key: 'talkToSales'
      }],
      'cms-hub-enterprise': [{
        key: 'talkToSales'
      }],
      'strategic-consulting-ongoing': [{
        key: 'talkToSales'
      }],
      'service-hub-enterprise-onboarding': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'calling-limit-increase': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'sales-hub-enterprise': [{
        key: 'talkToSales'
      }],
      'service-hub-starter-onboarding': [{
        key: 'talkToSales'
      }],
      'training-agency-marketing-hub-fundamentals': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'domains-limit-increase': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'marketing-hub-professional': [{
        key: 'talkToSales'
      }],
      'premium-consulting': [{
        key: 'talkToSales'
      }],
      'api-limit-increase': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'transactional-email': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'marketing-hub-starter-onboarding': [{
        key: 'talkToSales'
      }],
      'operations-hub-enterprise': [{
        key: 'trial'
      }, {
        key: 'talkToSales'
      }],
      'sales-hub-enterprise-onboarding': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'cms-hub-professional': [{
        key: 'talkToSales'
      }],
      'ads-limit-increase': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'brazil-onboarding': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'marketing-hub-enterprise': [{
        key: 'talkToSales'
      }],
      'cms-hub-enterprise-onboarding': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'sales-hub-professional': [{
        key: 'talkToSales'
      }],
      'marketing-hub-professional-onboarding': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'strategic-consulting-monthly': [{
        key: 'talkToSales'
      }],
      'operations-hub-starter': [{
        key: 'buyTouchless'
      }],
      'sales-hub-professional-onboarding': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'service-hub-professional': [{
        key: 'talkToSales'
      }],
      'sales-hub-starter-onboarding': [{
        key: 'talkToSales'
      }],
      'cms-hub-starter': [{
        key: 'buyTouchless'
      }],
      'brand-domain': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'service-hub-professional-onboarding': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'hubspot-for-startups-setup': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'reporting-limit-increase': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }],
      'transcription-limit-increase': [{
        key: 'buyTouchless'
      }, {
        key: 'talkToSales'
      }]
    }
  }
};